import { useConfirm } from 'hooks/useDialog'
import { useRef } from 'react'
import { useBlocker } from 'react-router-dom'

export default function useLeavingPrompt({ message, when }) {
  const confirm = useConfirm()
  const showing = useRef(false) // to prevent showing dialog 2 times
  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      when && currentLocation !== nextLocation,
  )

  if (blocker.state === 'blocked' && !showing.current) {
    showing.current = true
    confirm({ message }).then(({ status }) => {
      status === 'confirmed' ? blocker.proceed() : blocker.reset()
      showing.current = false
    })
  }
}
